export default __webpack_public_path__ + "static/media/selectedCheckBox.f7038068.svg";